import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const LINKS = [
  { to: '/',                           label: 'HomePage' },
  { to: '/potd',                       label: 'Problems' },
    // { to: '/lc-problems', label: 'LC Problems', soon: true },
  { to: '/sheets',                     label: 'Sheets' },
  // { to: '/sheets/striver-challenge',   label: 'Striver SDE Sheet' }
];

export default function Navbar() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  /* Close mobile menu on route change */
  useEffect(() => { setMenuOpen(false); }, [pathname]);

  return (
    <header className={`nb ${scrolled ? 'nb--scrolled' : ''}`}>
      <div className="nb__inner">
        {/* ── Logo ── */}
        <Link className="nb__logo" to="/">
          <span className="nb__logo-bracket">&lt;</span>
          <span className="ft__logo-name">CodeCrusaders </span>
          <span className="ft__logo-lc"> LC</span><span className="nb__logo-bracket"> /&gt;</span>
        </Link>

        {/* ── Desktop links ── */}
        <nav className="nb__links">
          {LINKS.map(l => {
            const active = l.to === '/'
              ? pathname === '/'
              : pathname.startsWith(l.to);
            return (
              <Link
                key={l.to}
                to={l.to}
                className={`nb__link${active ? ' nb__link--on' : ''}`}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>

        {/* ── Right ── */}
        <div className="nb__right">
          <a
            className="nb__lc-btn"
            href="https://leetcode.com/u/nandini-gangrade/"
            target="_blank"
            rel="noreferrer"
          >
            My LC ↗
          </a>
          <button
            className={`nb__ham ${menuOpen ? 'nb__ham--open' : ''}`}
            aria-label="Toggle menu"
            onClick={() => setMenuOpen(v => !v)}
          >
            <span className="nb__ham-bar" />
            <span className="nb__ham-bar" />
            <span className="nb__ham-bar" />
          </button>
        </div>
      </div>

      {/* ── Mobile menu ── */}
      {menuOpen && (
        <nav className="nb__mobile">
          {LINKS.map(l => (
            <Link
              key={l.to}
              to={l.to}
              className={`nb__mobile-link${pathname === l.to ? ' nb__mobile-link--on' : ''}`}
            >
              {l.label}
            </Link>
          ))}
          <a
            className="nb__mobile-link"
            href="https://leetcode.com/u/nandini-gangrade/"
            target="_blank"
            rel="noreferrer"
          >
            My LeetCode ↗
          </a>
        </nav>
      )}
    </header>
  );
}
